import Home from "./Home";
import Landing from "./Landing";
import Contact from "./Contact";
import Work from "./Work";
import Education from "./Education";

export { Home, Landing, Contact, Work, Education };
